import { Menu } from "./menu";
import { Status } from "./status";

export class StatusMenuId{
    status?: Status;
    menu?: Menu;
}

export class StatusMenu{
    id: StatusMenuId = new StatusMenuId();
    createdAt?: Date = new Date();
}
